
import funcTranslateHelper from '../../../i18next/funcTranslateHelper';
import {
  generateAction,
  generateSchemaAssetType,
  mergeActions,
  saveConfig
} from './utils';

export const onAdd = (
  formData,
  currentStep,
  assetTypes,
  config,
  actions,
  data,
  setData,
  actionToEdit,
  setActionToEdit,
  _next,
  saveTempConfigFile,
  setNotification,
  open,
  toggleForm
) => {
  let newAction;
  try {
    switch (currentStep) {
      default: {
        newAction = generateAction(formData, assetTypes, config);
        setActionToEdit(newAction);
        const assetType = assetTypes.find(assetType => assetType.id === newAction.assetType);
        const [schemaAssetType, uiSchemaAssetType] = generateSchemaAssetType(assetType);
        const newData = [
          { ...data[0], formData },
          { ...data[1], schema: schemaAssetType, uiSchema: uiSchemaAssetType }];
        setData(newData);
        _next();
        break;
      }
      case 1: {
        const finalAction = mergeActions(actionToEdit, formData);
        const configFile = {
          ...config,
          actions: [...actions, finalAction]
        };
        saveConfig(configFile, saveTempConfigFile, setNotification, open, toggleForm);
        break;
      }
    }
  } catch (err) {
    console.error(err);
    setNotification({
      type: 'error',
      message: funcTranslateHelper('Builder.Message.error')
    });
    setTimeout(() => setNotification(null), 2000);
    if (open) toggleForm();
  }
};
